import { j as a } from "../../modules/index.es3.js";
import { Root as d, Item as l, Header as m, Trigger as n, Content as c } from "../../modules/index.es5.js";
import * as r from "react";
import { cn as i } from "../../utils/styling.es.js";
import f from "../../modules/index.es6.js";
const p = r.forwardRef(({ className: e, ...o }, s) => /* @__PURE__ */ a.jsx(
  d,
  {
    ref: s,
    className: i("w-full", e),
    ...o
  }
));
p.displayName = "Accordion";
const u = r.forwardRef(({ className: e, ...o }, s) => /* @__PURE__ */ a.jsx(l, { ref: s, className: i("", e), ...o }));
u.displayName = "AccordionItem";
const x = r.forwardRef(({ className: e, children: o, ...s }, t) => /* @__PURE__ */ a.jsx(m, { asChild: !0, className: "flex", children: /* @__PURE__ */ a.jsxs(
  n,
  {
    ref: t,
    className: i(
      "flex flex-1 w-full items-center justify-between [&[data-state=open]>svg]:rotate-180 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:rounded",
      e
    ),
    ...s,
    children: [
      o,
      /* @__PURE__ */ a.jsx(f, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
    ]
  }
) }));
x.displayName = n.displayName;
const N = r.forwardRef(({ className: e, children: o, ...s }, t) => /* @__PURE__ */ a.jsx(
  c,
  {
    ref: t,
    className: "overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...s,
    children: /* @__PURE__ */ a.jsx("div", { className: i("", e), children: o })
  }
));
N.displayName = c.displayName;
export {
  p as Accordion,
  N as AccordionContent,
  u as AccordionItem,
  x as AccordionTrigger
};
//# sourceMappingURL=Accordion.es.js.map
